import { createEntityAdapter } from '@reduxjs/toolkit';
import { stringPropertyComparator } from '@utils/common.utils';
import { sortDate } from '@utils/date.utils';

import { NotificationType } from '@/types/data/data.types';

export const notificationAdapter = createEntityAdapter<NotificationType, string>({
  selectId: (notification) => notification.id,
  sortComparer: (notification1, notification2) => {
    const sortValue = sortDate(notification1.startTime, notification2.startTime);
    if (sortValue === 0) {
      return stringPropertyComparator('id')(notification1, notification2);
    }
    return sortValue;
  },
});
